import { render, staticRenderFns } from "./SubjectExistingAstYN.vue?vue&type=template&id=5d70b352"
import script from "./SubjectExistingAstYN.vue?vue&type=script&lang=js"
export * from "./SubjectExistingAstYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports